/**
 * Per-line styling for the signup copy.
 *
 * Each of the four text slots on the public signup form — the card header's
 * title/subtitle and the first step's title/subtitle — can be individually
 * hidden, or given its own font and colour, via `venue.signup_text_styles`:
 *
 *   { "welcome_title": { enabled: false },
 *     "choice_title":  { font: "Montserrat", color: "#b91c1c" } }
 *
 * Anything unset inherits the venue's global font_family / text_color, so a
 * venue that never touches this looks exactly as it did before.
 *
 * Used by both the public form and the admin live preview so they can't drift.
 */

/** The slots that can be styled, in the order they appear on the form. */
export const SIGNUP_TEXT_SLOTS = [
  { key: "welcome_title",    label: "Welcome Title",       group: "Card header", hint: "Heading at the top of the signup card, beside the logo." },
  { key: "welcome_subtitle", label: "Welcome Subtitle",    group: "Card header", hint: "Sub-line under the card heading." },
  { key: "choice_title",     label: "First Step Title",    group: "First step",  hint: "Heading on the existing-vs-new step." },
  { key: "choice_subtitle",  label: "First Step Subtitle", group: "First step",  hint: "Question under that heading." },
];

/** Fonts offered per line — mirrors the venue-wide Font Family list. */
export const FONT_OPTIONS = [
  "Inter", "Roboto", "Open Sans", "Poppins", "Montserrat",
  "Lato", "DM Sans", "Nunito", "Source Sans 3",
];

/** Raw style entry for one slot (never null). */
export function slotStyle(venue, key) {
  const all = (venue && venue.signup_text_styles) || {};
  return all[key] || {};
}

/** Is this line shown? Defaults to true so unset venues are unchanged. */
export function isSlotVisible(venue, key) {
  return slotStyle(venue, key).enabled !== false;
}

/**
 * Inline style for a slot — only sets what the venue overrode, letting the
 * global font/colour cascade through for everything else.
 */
export function slotCss(venue, key, fallbackColor) {
  const s = slotStyle(venue, key);
  const css = {};
  if (s.font)  css.fontFamily = `'${s.font}', sans-serif`;
  if (s.color) css.color = s.color;
  else if (fallbackColor) css.color = fallbackColor;
  return css;
}
